import {
  fetchCurrentOrgSubscription,
  setCurrentOrganizationsTariffesInfo,
} from "../store/tariffesSlice";

export const updateTariffes = async (userOrganizations, dispatch) => {
  const organizationsTariffes = {};

  for (let i = 0; i < userOrganizations.length; i++) {
    const orgId = userOrganizations[i].id;
    const orgTariffInfoResponse = await dispatch(
      fetchCurrentOrgSubscription({ orgId })
    );
    const orgTariffInfo = (!orgTariffInfoResponse.error && {
      ...orgTariffInfoResponse.payload,
    }) || {
      id: orgId,
      plan: null,
    };
    organizationsTariffes[orgId] = orgTariffInfo;
  }

  dispatch(setCurrentOrganizationsTariffesInfo(organizationsTariffes));
};
